/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Driver_Next_Stop_All_DeliveredInputs */

const vi_dashboard_driver_next_stop_all_delivered = /** @type {(inputs: Dashboard_Driver_Next_Stop_All_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã giao hết đơn trong chuyến.`)
};

/**

* @param {Dashboard_Driver_Next_Stop_All_DeliveredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_next_stop_all_delivered = /** @type {((inputs?: Dashboard_Driver_Next_Stop_All_DeliveredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_Next_Stop_All_DeliveredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_next_stop_all_delivered(inputs)
});